import { InboundETransferTransactionResponse, InboundETransferTransactionRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchInboundETransferTransaction({ bearer }: { bearer?: string }) {
  const [fetching, setFetching] = useState(false);

  const [inboundETransferTransaction, setInboundETransferTransaction] = useState<InboundETransferTransactionResponse>();

  async function fetchInboundETransferTransaction(params: InboundETransferTransactionRequest) {
    try {
      setFetching(true);
      const res = await api.fetchInboundETransferTransaction(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setInboundETransferTransaction(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, inboundETransferTransaction, fetchInboundETransferTransaction };
}
